export default __webpack_public_path__ + "static/media/why-choose-us-bg.202bf8f2.jpg";